import { ReportVersionsService } from './report-versions.service';

export default angular
  .module('sfMobile.services.report-versions', [
    'sfMobile.services.crud',
    'sfMobile.config.database',
  ])
  .service('reportVersionsService', ReportVersionsService).name;
